import React from 'react';
import {
  Card,
  Table,
  Icon,
  Popup,
  Modal,
  Image,
  Header,
  Button,
} from 'semantic-ui-react';
import numeral from 'numeral';
import _ from 'lodash';

const colorMap = {
  instagram: 'pink',
  twitter: 'blue',
  snapchat: 'yellow',
};

const cf = num => (num ? numeral(num).format('0,0') : '-');

const ReportNetworkActivity = ({ posts }) => (
  <Card fluid color="blue">
    <Card.Content>
      <Card.Header>
      Network activity
      </Card.Header>
      <Card.Meta>
      Significant posts from other Influencers in Callux&apos;s Network
      </Card.Meta>
    </Card.Content>
    <Card.Content>
      <Table celled fluid size="small" basic="very">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell collapsing>channel</Table.HeaderCell>
            <Table.HeaderCell width={2}>influencer</Table.HeaderCell>
            <Table.HeaderCell width={2}>followers</Table.HeaderCell>
            <Table.HeaderCell>description</Table.HeaderCell>
            <Table.HeaderCell>impressions/views</Table.HeaderCell>
            <Table.HeaderCell>engagements</Table.HeaderCell>
            <Table.HeaderCell>
              <Popup
                trigger={<span>screenshot</span>}
                content="supporting screenshot"
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            _.map(posts, post => (
              <Table.Row>
                <Table.Cell textAlign="center">
                  <Icon name={post.platform} size="large" color={colorMap[post.platform]} />
                </Table.Cell>
                <Table.Cell><b>{ post.influencer }</b></Table.Cell>
                <Table.Cell>{ post.followers }</Table.Cell>
                <Table.Cell>
                  {
                    post.url
                      ? <a href={post.url} target="_blank">{ post.title }</a>
                      : post.title
                  }
                </Table.Cell>
                <Table.Cell textAlign="center">{ cf(post.views) }</Table.Cell>
                <Table.Cell textAlign="center">{ cf(post.engagements) }</Table.Cell>
                <Table.Cell textAlign="center">
                  <Modal trigger={<Button icon="file image outline" circular basic color="pink" />} size="small">
                    <Header icon="file image outline" content="Supporting screenshot" />
                    <Modal.Content>
                      <Image src={post.screenshot} size="medium" bordered centered />
                      <h4>Extracted Data</h4>
                      <Table celled fluid size="small" basic="very">
                        <Table.Body>
                          <Table.Row>
                            <Table.Cell>
                                impressions/views
                            </Table.Cell>
                            <Table.Cell>
                              { cf(post.views) }
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.Cell>
                                engagements
                            </Table.Cell>
                            <Table.Cell>
                              { cf(post.engagements) }
                            </Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                    </Modal.Content>
                    <Modal.Actions style={{ textAlign: 'center' }}>
                      <h4>press ESCAPE to close</h4>
                    </Modal.Actions>
                  </Modal>
                </Table.Cell>
              </Table.Row>
            ))
          }
          <Table.Row>
            <Table.Cell collapsing />
            <Table.Cell />
            <Table.Cell />
            <Table.Cell><h4>TOTALS</h4></Table.Cell>
            <Table.Cell textAlign="center"><h4>{ cf(_.reduce(posts, (sum, n) => (sum + (n.views || 0)), 0)) }</h4></Table.Cell>
            <Table.Cell textAlign="center"><h4>{ cf(_.reduce(posts, (sum, n) => (sum + (n.engagements || 0)), 0)) }</h4></Table.Cell>
            <Table.Cell />
            <Table.Cell />
          </Table.Row>

        </Table.Body>
      </Table>
      <p>&nbsp;</p>
    </Card.Content>

    <Card.Content extra>
      <p>twitter engagements are calculated as retweets + link clicks + follows + likes</p>
      <p>instagram engagements are calculated as likes + comments + saves</p>
    </Card.Content>
  </Card>
);

export default ReportNetworkActivity;



// WEBPACK FOOTER //
// ./src/components/report-network-activity/index.js